module.exports = __webpack_public_path__ + "files/5a61d56ce03285d9663c0979cc98a0a6.png";